"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Permissions = void 0;
var Permissions;
exports.Permissions = Permissions;

(function (Permissions) {
  Permissions["ASSIGN_TASKS_TO"] = "ASSIGN_TASKS_TO";
  Permissions["DELETE_TASK"] = "DELETE_TASK";
  Permissions["DELETE_TASK_CONDITIONALLY"] = "DELETE_TASK_CONDITIONALLY";
  Permissions["EDIT_TASK"] = "EDIT_TASK";
  Permissions["EDIT_TASK_CONDITIONALLY"] = "EDIT_TASK_CONDITIONALLY";
  Permissions["COMPLETE_TASK"] = "COMPLETE_TASK";
  Permissions["COMPLETE_TASK_CONDITIONALLY"] = "COMPLETE_TASK_CONDITIONALLY";
  Permissions["ORGANIZATION_UPDATE"] = "ORGANIZATION_UPDATE";
  Permissions["ORGANIZATION_USER"] = "ORGANIZATION_USER";
  Permissions["PROJECT_CREATE"] = "PROJECT_CREATE";
  Permissions["PROJECT_DATA_UPDATE"] = "PROJECT_DATA_UPDATE";
  Permissions["PROJECT_DELETE"] = "PROJECT_DELETE";
  Permissions["PROJECT_DETAILS_READ"] = "PROJECT_DETAILS_READ";
  Permissions["PROJECT_DETAILS_UPDATE"] = "PROJECT_DETAILS_UPDATE";
  Permissions["PROJECT_STYLE_UPDATE"] = "PROJECT_STYLE_UPDATE";
  Permissions["PROJECT_USER_UPDATE"] = "PROJECT_USER_UPDATE";
})(Permissions || (exports.Permissions = Permissions = {}));